export class RequestsFiltersDrawer {
    constructor(options = {}) {
        this.toggleSelector = options.toggleSelector || '#filters';
        this.overlaySelector = options.overlaySelector || '#requests-filters-overlay';
        this.drawerSelector = options.drawerSelector || '#requests-filters-drawer';
        this.fieldSelector = options.fieldSelector || '[data-filter-field]';
        this.closeSelector = options.closeSelector || '[data-filters-close]';
        this.applySelector = options.applySelector || '[data-filters-apply]';
        this.resetSelector = options.resetSelector || '[data-filters-reset]';
        this.onApply = typeof options.onApply === 'function' ? options.onApply : null;
        this.onReset = typeof options.onReset === 'function' ? options.onReset : null;
    }

    init() {
        this.toggle = document.querySelector(this.toggleSelector);
        this.overlay = document.querySelector(this.overlaySelector);
        this.drawer = document.querySelector(this.drawerSelector);

        if (!this.toggle || !this.overlay || !this.drawer) {
            return false;
        }

        this.closeButton = this.drawer.querySelector(this.closeSelector);
        this.applyButton = this.drawer.querySelector(this.applySelector);
        this.resetButton = this.drawer.querySelector(this.resetSelector);
        this.fields = Array.from(this.drawer.querySelectorAll(this.fieldSelector));

        this.bindEvents();
        return true;
    }

    bindEvents() {
        this.onToggleClick = (e) => {
            e.preventDefault();
            this.open();
        };
        this.onOverlayClick = () => this.close();
        this.onCloseClick = () => this.close();
        this.onEscape = (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        };
        this.onApplyClick = () => {
            if (this.onApply) {
                this.onApply(this.getValues());
            }
            this.close();
        };
        this.onResetClick = () => {
            this.resetFields();
            if (this.onReset) {
                this.onReset(this.getValues());
            }
            this.close();
        };

        this.toggle.addEventListener('click', this.onToggleClick);
        this.overlay.addEventListener('click', this.onOverlayClick);
        this.closeButton?.addEventListener('click', this.onCloseClick);
        this.applyButton?.addEventListener('click', this.onApplyClick);
        this.resetButton?.addEventListener('click', this.onResetClick);
        document.addEventListener('keydown', this.onEscape);
    }

    open() {
        this.overlay.classList.add('active');
        this.drawer.classList.add('active');
        this.overlay.setAttribute('aria-hidden', 'false');
        this.drawer.setAttribute('aria-hidden', 'false');
    }

    close() {
        this.overlay.classList.remove('active');
        this.drawer.classList.remove('active');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.drawer.setAttribute('aria-hidden', 'true');
    }

    resetFields() {
        this.fields.forEach((field) => {
            field.value = '';
        });
    }

    getValues() {
        return this.fields.reduce((acc, field) => {
            const key = String(field.getAttribute('data-filter-field') || '').trim();
            if (!key) {
                return acc;
            }
            acc[key] = String(field.value || '').trim();
            return acc;
        }, {});
    }
}

